/**
 * LUMA JEWELLERY — Product Page Configurator
 * File: assets/luma-product-configurator.js
 * Updated: May 2026
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var wrap = document.getElementById('luma-config');
    if (!wrap) return;

    var state = {
      step: 1, timeline: null, metal: null, size: null, shape: null,
      caratMin: 1.0, caratMax: 1.49, caratValues: [1.0],
      clarities: ['FL', 'IF', 'VVS1', 'VVS2'], colours: ['D', 'E', 'F'], diamond: null
    };

    var basePrice     = parseInt(wrap.getAttribute('data-base-price') || '0', 10);
    var rushPrice     = parseInt(wrap.getAttribute('data-rush-price') || '49900', 10);
    var currencyCode  = wrap.getAttribute('data-currency') || 'GBP';
    var diamondApiUrl = wrap.getAttribute('data-diamond-api') || '';
    var caratPrices   = {};
    var metalPrices   = {};
    try { var rawCarat = wrap.getAttribute('data-carat-prices'); if (rawCarat && rawCarat !== '') caratPrices = JSON.parse(rawCarat); } catch (e) {}
    try { var rawMetal = wrap.getAttribute('data-metal-prices'); if (rawMetal && rawMetal !== '') metalPrices = JSON.parse(rawMetal); } catch (e) {}
    var rushVariantId = wrap.getAttribute('data-rush-variant-id') || '';
    var productTitle  = wrap.getAttribute('data-product-title') || 'Ring';

    function formatMoney(pence) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currencyCode, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(pence / 100); }
    function metalBase() { if (state.metal && metalPrices[state.metal] !== undefined) return parseInt(metalPrices[state.metal], 10); return basePrice; }
    function calcPrice() { if (!state.diamond) return null; var dp = state.diamond.price || 0; var ru = state.timeline === 'priority' ? rushPrice : 0; return metalBase() + dp + ru; }
    function calcFromPrice() { var base = metalBase(); if (!base) return null; var ru = state.timeline === 'priority' ? rushPrice : 0; return base + ru; }
    function qs(s, c)  { return (c || wrap).querySelector(s); }
    function qsa(s, c) { return (c || wrap).querySelectorAll(s); }
    function capitalise(s) { if (!s) return ''; return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); }

    function goToStep(n) {
      state.step = n;
      qsa('.luma-config__panel').forEach(function (p) { p.classList.toggle('is-active', parseInt(p.getAttribute('data-panel'), 10) === n); });
      qsa('.luma-config__step-tab').forEach(function (t) {
        var tN = parseInt(t.getAttribute('data-step'), 10);
        t.classList.remove('is-active', 'is-done');
        if (tN === n) t.classList.add('is-active');
        else if (tN < n) t.classList.add('is-done');
      });
      wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function setNextEnabled(panel, en) { var b = qs('.luma-config__btn--next', panel); if (!b) return; b.disabled = !en; b.classList.toggle('is-disabled', !en); }
    function validateStep1() { return !!state.timeline; }
    function validateStep2() { return !!state.metal && !!state.size; }
    function validateStep3() { return !!state.diamond; }
    function revalidate(sn) { var p = qs('.luma-config__panel[data-panel="' + sn + '"]'); if (!p) return; var v = sn === 1 ? validateStep1() : sn === 2 ? validateStep2() : sn === 3 ? validateStep3() : false; setNextEnabled(p, v); }
    function refreshPagePrice() {
      var pe = document.querySelector('.price__regular .price-item--regular') || document.querySelector('.price-item--regular');
      if (!pe) return;
      var ex = calcPrice();
      if (ex !== null) pe.textContent = formatMoney(ex);
      else if (state.timeline !== null || state.metal !== null) { var f = calcFromPrice(); if (f !== null) pe.textContent = 'From ' + formatMoney(f); }
    }
    function updateSummary() {
      function set(a, v) { var e = qs('[' + a + ']'); if (e) e.textContent = v || '—'; }
      var tl = state.timeline === 'priority' ? 'Priority (2 weeks) +£499' : state.timeline === 'standard' ? 'Standard (4 to 6 weeks)' : '—';
      var sl = state.size === 'decide-later' ? "I'll decide later" : (state.size || '—');
      set('data-summary-timeline', tl);
      set('data-summary-metal', state.metal || '—');
      set('data-summary-size', sl);
      set('data-summary-setting-price', state.metal ? formatMoney(metalBase()) : '—');
      if (state.diamond) {
        var c = (state.diamond.diamond && state.diamond.diamond.certificate) ? state.diamond.diamond.certificate : {};
        var cl = (c.lab && c.lab !== 'NONE') ? (c.lab + ' ' + c.certNumber) : (c.certNumber || '—');
        set('data-summary-diamond-shape', capitalise(state.shape));
        set('data-summary-diamond-carat', (c.carats || 0).toFixed(2) + 'ct');
        set('data-summary-diamond-clarity', c.clarity || '—');
        set('data-summary-diamond-colour', c.color || '—');
        set('data-summary-diamond-cut', c.cut || '—');
        set('data-summary-diamond-cert', cl);
        set('data-summary-diamond-price', formatMoney(state.diamond.price || 0));
      }
      var tot = calcPrice();
      var pe = qs('[data-summary-price]');
      if (pe) pe.textContent = tot !== null ? formatMoney(tot) : '—';
      var ab = document.getElementById('luma-config-atc');
      if (ab) ab.textContent = 'Reserve Your Ring';
      if (ab && !qs('.luma-config__deposit-notice')) {
        var n = document.createElement('div');
        n.className = 'luma-config__deposit-notice';
        n.innerHTML = '<span class="luma-config__deposit-notice-icon">◆</span><p>A 50% deposit is taken today to reserve your ring. The balance is due before we begin making your order.</p><p class="luma-config__deposit-terms">Your deposit is fully refundable within 7 days of placing your order. Once we have sourced your diamond, cancellations will incur a charge of 50% of the deposit paid. Our team will confirm when your stone has been ordered.</p>';
        var nr = ab.closest('.luma-config__nav');
        var it = nr || ab;
        it.parentNode.insertBefore(n, it);
      }
    }
    function populateForm() {
      function setVal(id, v) { var e = document.getElementById(id); if (e) e.value = v || ''; }
      var tv = state.timeline === 'priority' ? 'Priority, ready in 2 weeks (+£499)' : 'Standard, ready in 4 to 6 weeks';
      setVal('lc-prop-timeline', tv);
      setVal('lc-prop-metal', state.metal || '');
      setVal('lc-prop-size', state.size === 'decide-later' ? 'To be confirmed' : (state.size || ''));
      if (state.diamond) {
        var c = (state.diamond.diamond && state.diamond.diamond.certificate) ? state.diamond.diamond.certificate : {};
        var cs = (c.lab && c.lab !== 'NONE') ? (c.lab + ' ' + c.certNumber) : (c.certNumber || '');
        setVal('lc-prop-diamond-id', state.diamond.id || '');
        setVal('lc-prop-diamond-shape', capitalise(state.shape) || '');
        setVal('lc-prop-diamond-carat', (c.carats || 0).toFixed(2) + 'ct Lab Grown');
        setVal('lc-prop-diamond-clarity', c.clarity || '');
        setVal('lc-prop-diamond-colour', c.color || '');
        setVal('lc-prop-diamond-cut', c.cut || '');
        setVal('lc-prop-diamond-cert', cs);
        setVal('lc-prop-diamond-price', formatMoney(state.diamond.price || 0));
      }
    }
    function fetchDiamonds() {
      var re = document.getElementById('luma-diamonds-results');
      if (!re) return;
      if (!state.shape) { re.innerHTML = '<p class="luma-config__diamonds-msg">Please select a diamond shape above first.</p>'; return; }
      if (!diamondApiUrl) { re.innerHTML = '<p class="luma-config__diamonds-msg">Diamond search is not yet configured. Please contact us to discuss your diamond.</p>'; return; }
      if (state.clarities.length === 0 || state.colours.length === 0) { re.innerHTML = '<p class="luma-config__diamonds-msg">Please select at least one clarity and one colour grade.</p>'; return; }
      re.innerHTML = '<p class="luma-config__diamonds-loading">Searching for diamonds…</p>';
      var p = new URLSearchParams({ shape: state.shape, carat_min: state.caratMin, carat_max: state.caratMax, clarities: state.clarities.join(','), colours: state.colours.join(',') });
      fetch(diamondApiUrl + '?' + p.toString())
        .then(function (r) { if (!r.ok) throw new Error('API ' + r.status); return r.json(); })
        .then(function (d) {
          var ds = (d.data && d.data.as && d.data.as.diamonds_by_query && d.data.as.diamonds_by_query.items) || [];
          if (ds.length === 0) { re.innerHTML = '<p class="luma-config__diamonds-msg">No diamonds found matching your criteria — try widening your carat range or adjusting your filters.</p>'; return; }
          renderDiamonds(ds, re);
        })
        .catch(function (err) { console.error('Luma diamond fetch error:', err); re.innerHTML = '<p class="luma-config__diamonds-msg">Unable to load diamonds right now. Please try again or <a href="/pages/contact">contact us</a>.</p>'; });
    }
    function renderDiamonds(ds, container) {
      var sp = metalBase();
      var ra = state.timeline === 'priority' ? rushPrice : 0;
      var h = '<div class="luma-config__diamonds-count">' + ds.length + ' diamond' + (ds.length === 1 ? '' : 's') + ' found</div><div class="luma-config__diamonds-grid">';
      ds.forEach(function (d) {
        var c = (d.diamond && d.diamond.certificate) ? d.diamond.certificate : {};
        var iu = (d.diamond && d.diamond.image) ? d.diamond.image : null;
        var vu = (d.diamond && d.diamond.video) ? d.diamond.video : null;
        var dp = d.price || 0;
        var tp = sp + dp + ra;
        var cl = (c.lab && c.lab !== 'NONE') ? (c.lab + ' · ' + c.certNumber) : (c.certNumber || '');
        var sp2 = [c.clarity, c.color, c.cut].filter(Boolean);
        var cr = c.carats || 0;
        h += '<div class="luma-config__diamond-card" data-diamond-id="' + d.id + '" data-luma-recommended="' + (d.luma_recommended === true ? 'true' : 'false') + '" data-luma-shortlist="' + (d.luma_shortlist === true ? 'true' : 'false') + '" role="button" tabindex="0"><div class="luma-config__diamond-media">';
        if (vu) h += '<img src="' + (iu || '') + '" alt="' + cr.toFixed(2) + 'ct diamond" loading="lazy"><span class="luma-config__diamond-media-play">▶</span>';
        else if (iu) h += '<img src="' + iu + '" alt="' + cr.toFixed(2) + 'ct diamond" loading="lazy">';
        else h += '<span class="luma-config__diamond-media-placeholder">◆</span>';
        h += '</div><div class="luma-config__diamond-info"><div class="luma-config__diamond-name">' + cr.toFixed(2) + 'ct ' + capitalise(state.shape) + '</div><div class="luma-config__diamond-specs">';
        sp2.forEach(function (s) { h += '<span>' + s + '</span>'; });
        if (cl) h += '<span class="luma-config__diamond-cert">' + cl + '</span>';
        h += '</div></div><div class="luma-config__diamond-price"><div class="luma-config__diamond-price-stone">' + formatMoney(dp) + '</div>';
        if (sp) h += '<div class="luma-config__diamond-price-total">Total ' + formatMoney(tp) + '</div>';
        h += '</div></div>';
      });
      h += '</div>';
      container.innerHTML = h;
      container.querySelectorAll('.luma-config__diamond-card').forEach(function (card) {
        function sc() {
          var id = card.getAttribute('data-diamond-id');
          var d = ds.find(function (x) { return String(x.id) === String(id); });
          if (!d) return;
          state.diamond = d;
          container.querySelectorAll('.luma-config__diamond-card').forEach(function (c) { c.classList.toggle('is-selected', c === card); });
          revalidate(3);
          refreshPagePrice();
        }
        card.addEventListener('click', sc);
        card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sc(); } });
      });
    }

    qsa('.luma-config__timeline-card').forEach(function (card) {
      card.addEventListener('click', function () {
        state.timeline = card.getAttribute('data-timeline');
        qsa('.luma-config__timeline-card').forEach(function (c) { c.classList.toggle('is-selected', c === card); });
        revalidate(1); refreshPagePrice();
      });
    });
    qsa('.luma-config__metal-group-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.getAttribute('data-group');
        var ia = btn.classList.contains('is-active');
        qsa('.luma-config__metal-group-btn').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-expanded', 'false'); });
        qsa('.luma-config__metal-sub').forEach(function (s) { s.classList.remove('is-open'); });
        if (ia) {
          state.metal = null;
          qsa('.luma-config__swatch-wrap').forEach(function (s) { s.classList.remove('is-selected'); });
          setInlineDisplay('data-display-metal', '');
          revalidate(2); refreshPagePrice();
          return;
        }
        btn.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
        var sub = qs('[data-group-sub="' + g + '"]');
        if (!sub) return;
        sub.classList.add('is-open');
        var ks = sub.querySelectorAll('.luma-config__swatch-wrap');
        if (ks.length === 1) ks[0].click();
      });
    });
    qsa('.luma-config__swatch-wrap').forEach(function (sw) {
      sw.addEventListener('click', function () {
        state.metal = sw.getAttribute('data-metal') || sw.getAttribute('title');
        qsa('.luma-config__swatch-wrap').forEach(function (s) { s.classList.toggle('is-selected', s === sw); });
        setInlineDisplay('data-display-metal', state.metal);
        revalidate(2); refreshPagePrice();
        switchToMetalImage(state.metal);
      });
      sw.addEventListener('mouseenter', function () { setInlineDisplay('data-display-metal', sw.getAttribute('data-metal') || sw.getAttribute('title')); });
      sw.addEventListener('mouseleave', function () { setInlineDisplay('data-display-metal', state.metal || ''); });
    });
    qsa('.luma-config__size-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        state.size = pill.getAttribute('data-size');
        qsa('.luma-config__size-pill').forEach(function (p) { p.classList.toggle('is-selected', p === pill); });
        var sl = state.size === 'decide-later' ? "I'll decide later" : state.size;
        setInlineDisplay('data-display-size', sl);
        revalidate(2);
      });
    });
    qsa('.luma-config__shape-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.shape = btn.getAttribute('data-shape');
        state.diamond = null;
        revalidate(3);
        qsa('.luma-config__shape-btn').forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
        switchToShapeImage(state.shape);
        var re = document.getElementById('luma-diamonds-results');
        if (re) re.innerHTML = '';
      });
    });
    qsa('.luma-config__carat-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var v = parseFloat(pill.getAttribute('data-carat'));
        var i = state.caratValues.indexOf(v);
        if (i === -1) { state.caratValues.push(v); pill.classList.add('is-selected'); }
        else if (state.caratValues.length > 1) { state.caratValues.splice(i, 1); pill.classList.remove('is-selected'); }
        state.caratMin = Math.min.apply(null, state.caratValues);
        state.caratMax = parseFloat((Math.max.apply(null, state.caratValues) + 0.49).toFixed(2));
        state.diamond = null;
        revalidate(3);
      });
    });
    qsa('[data-clarity-filter]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var v = pill.getAttribute('data-clarity-filter');
        var i = state.clarities.indexOf(v);
        if (i === -1) { state.clarities.push(v); pill.classList.add('is-selected'); }
        else if (state.clarities.length > 1) { state.clarities.splice(i, 1); pill.classList.remove('is-selected'); }
        state.diamond = null; revalidate(3);
      });
    });
    qsa('[data-colour-filter]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var v = pill.getAttribute('data-colour-filter');
        var i = state.colours.indexOf(v);
        if (i === -1) { state.colours.push(v); pill.classList.add('is-selected'); }
        else if (state.colours.length > 1) { state.colours.splice(i, 1); pill.classList.remove('is-selected'); }
        state.diamond = null; revalidate(3);
      });
    });
    var browseBtn = document.getElementById('luma-browse-btn');
    if (browseBtn) browseBtn.addEventListener('click', function () { state.diamond = null; revalidate(3); fetchDiamonds(); });
    qsa('.luma-config__btn--next').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.classList.contains('is-disabled')) return;
        var n = parseInt(btn.getAttribute('data-next'), 10);
        if (n === 4) updateSummary();
        goToStep(n);
      });
    });
    qsa('.luma-config__btn--back').forEach(function (btn) { btn.addEventListener('click', function () { goToStep(parseInt(btn.getAttribute('data-back'), 10)); }); });
    qsa('.luma-config__summary-edit[data-goto]').forEach(function (link) { link.addEventListener('click', function () { goToStep(parseInt(link.getAttribute('data-goto'), 10)); }); });
    qsa('.luma-config__step-tab').forEach(function (tab) {
      tab.addEventListener('click', function () { if (!tab.classList.contains('is-done')) return; goToStep(parseInt(tab.getAttribute('data-step'), 10)); });
      tab.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tab.click(); } });
    });

    var orderApiUrl = diamondApiUrl.replace('/api/diamonds', '/api/create-draft-order');
    var form = document.getElementById('luma-config-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        populateForm();
        var ab = document.getElementById('luma-config-atc');
        if (ab) { ab.disabled = true; ab.textContent = 'Reserving…'; }
        var c = (state.diamond && state.diamond.diamond && state.diamond.diamond.certificate) ? state.diamond.diamond.certificate : {};
        var payload = {
          product_title: productTitle, metal: state.metal || '',
          size: state.size === 'decide-later' ? 'To be confirmed' : (state.size || ''),
          timeline: state.timeline === 'priority' ? 'Priority, ready in 2 weeks' : 'Standard, ready in 4 to 6 weeks',
          setting_price_pence: metalBase(),
          diamond_price_pence: state.diamond ? (state.diamond.price || 0) : 0,
          diamond_id: state.diamond ? (state.diamond.id || '') : '',
          diamond_shape: capitalise(state.shape) || '',
          diamond_carats: c.carats || 0, diamond_clarity: c.clarity || '', diamond_color: c.color || '',
          diamond_cut: c.cut || '', diamond_polish: c.polish || '', diamond_symmetry: c.symmetry || '',
          diamond_cert_lab: c.lab || '', diamond_cert_number: c.certNumber || '',
          rush_variant_id: state.timeline === 'priority' ? rushVariantId : '',
          rush_price_pence: state.timeline === 'priority' ? rushPrice : 0,
          attribution: (window.LumaAttribution && window.LumaAttribution.get) ? window.LumaAttribution.get() : null,
          attribution_summary: (window.LumaAttribution && window.LumaAttribution.summary) ? window.LumaAttribution.summary() : '',
          /* Added 24 Aug 2026 for server side price verification. The proxy
             cannot check setting_price_pence against Shopify without knowing
             which product it is. data-product-id was already on the root
             element, so this needs no Liquid change. client_total_pence is
             sent purely so the proxy can compare its own calculation against
             what the browser showed and reject a mismatch rather than
             silently pricing something differently from the page. */
          product_id: wrap.getAttribute('data-product-id') || '',
          client_total_pence: calcPrice() || 0
        };
        fetch(orderApiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) { console.error('[Luma] Draft order HTTP ' + r.status, d); throw new Error('HTTP ' + r.status + ': ' + JSON.stringify(d)); } return d; }); })
          .then(function (d) {
            if (!d.checkout_url) { console.error('[Luma] No checkout_url in response:', d); throw new Error('No checkout URL returned'); }
            /* GA4, added 24 Aug 2026. Fired BEFORE the redirect, because the
               redirect below is synchronous and would otherwise cut the hit off.
               transport_type beacon plus a 600ms fallback timer means the
               customer is never held up if gtag is slow or absent.
               Event is begin_checkout, not purchase: the customer still has to
               pay on the Shopify invoice, and Shopify's own GA4 integration
               fires purchase there. Using purchase here would double count. */
            var dest = d.checkout_url;
            var went = false;
            function go() { if (went) return; went = true; window.location.href = dest; }
            var a = (window.LumaAttribution && window.LumaAttribution.get) ? window.LumaAttribution.get() : {};
            var totalPence = calcPrice() || 0;
            var params = {
              currency: currencyCode,
              value: totalPence / 100,
              items: [{
                item_id: (c.certNumber || (state.diamond && state.diamond.id)) || 'configurator',
                item_name: productTitle,
                item_variant: [state.metal, capitalise(state.shape), (c.carats || '') + 'ct'].filter(Boolean).join(' / '),
                item_category: 'Engagement ring',
                price: totalPence / 100,
                quantity: 1
              }],
              luma_setting_price: metalBase() / 100,
              luma_diamond_price: (state.diamond ? (state.diamond.price || 0) : 0) / 100,
              luma_timeline: state.timeline || '',
              luma_first_source: a.attr_first_source || 'Direct',
              luma_first_medium: a.attr_first_medium || 'none',
              luma_visits: a.attr_visits || 1,
              luma_days_to_order: a.attr_days_to_order || 0
            };
            try {
              /* dataLayer gets the clean object. gtag gets a copy with the
                 transport keys bolted on, so no function reference ever lands
                 in dataLayer where GTM would have to render it. */
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ event: 'luma_configurator_reserve', ecommerce: params });
              if (typeof window.gtag === 'function') {
                var gaParams = {};
                for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k)) gaParams[k] = params[k]; }
                gaParams.transport_type = 'beacon';
                gaParams.event_callback = go;
                window.gtag('event', 'begin_checkout', gaParams);
              }
            } catch (e) { console.error('[Luma] GA4 event failed:', e); }
            window.setTimeout(go, 600);
          })
          .catch(function (err) { console.error('[Luma] Order error — open this to diagnose:', err.message); if (ab) { ab.disabled = false; ab.textContent = 'Reserve Your Ring'; } alert('Sorry, there was a problem placing your order. Please try again or contact us directly.'); });
      });
    }

    // ═══ SHAPE BUTTON FILTERING (2026-05-20): read available shapes from product variants ═══
    function findAvailableShapesFromDOM() {
      var found = [];
      function pushFrom(el) {
        var v = (el && (el.value || el.textContent) || '').trim();
        if (v) found.push(v);
      }
      // Strategy A: variant picker fieldsets / pills (Dawn variant-selects)
      var fieldsets = document.querySelectorAll('variant-selects fieldset, variant-radios fieldset, .product-form__input--pill, .product-form__input--swatch, .product-form__input');
      for (var i = 0; i < fieldsets.length; i++) {
        var legend = fieldsets[i].querySelector('legend');
        var labelTxt = legend ? (legend.textContent || '') : '';
        if (!labelTxt) { var lbl = fieldsets[i].querySelector('label.form__label'); if (lbl) labelTxt = lbl.textContent || ''; }
        var lower = labelTxt.toLowerCase();
        if (lower.indexOf('shape') === -1 && lower.indexOf('cut') === -1) continue;
        fieldsets[i].querySelectorAll('input[type=radio], option').forEach(pushFrom);
        fieldsets[i].querySelectorAll('label').forEach(function(l){ var t = (l.textContent || '').trim(); if (t) found.push(t); });
        if (found.length) return found;
      }
      // Strategy B: select dropdown named options[Shape] etc
      var selects = document.querySelectorAll('select[name*="hape" i], select[name*="ut" i], select[id*="hape" i], select[id*="ut" i]');
      for (var j = 0; j < selects.length; j++) {
        selects[j].querySelectorAll('option').forEach(pushFrom);
        if (found.length) return found;
      }
      // Strategy C: data-all-variants JSON + option name from a Shape legend/label
      var allVar = document.querySelector('script[type="application/json"][data-all-variants]');
      if (allVar) {
        try {
          var variants = JSON.parse(allVar.textContent || '[]');
          // Determine which option index is the shape: look at the variant-selects legends order
          var legends = document.querySelectorAll('variant-selects fieldset legend, variant-selects .product-form__input label.form__label');
          var shapeIdx = -1;
          for (var li = 0; li < legends.length; li++) {
            var lt = (legends[li].textContent || '').toLowerCase();
            if (lt.indexOf('shape') !== -1 || lt.indexOf('cut') !== -1) { shapeIdx = li; break; }
          }
          variants.forEach(function (v) {
            var val = '';
            if (shapeIdx >= 0) val = v['option' + (shapeIdx + 1)] || '';
            if (!val && v.options) { for (var oi = 0; oi < v.options.length; oi++) { var ov = (v.options[oi] || '').toLowerCase(); for (var w in SHAPE_WORDS) { if (ov.indexOf(w) !== -1) val = v.options[oi]; } } }
            if (val) found.push(val);
          });
          if (found.length) return found;
        } catch (e) {}
      }
      return null;
    }

    function filterAvailableShapes() {
      var SW = {'round':'round','oval':'oval','cushion':'cushion','princess':'princess','emerald':'emerald','pear':'pear','marquise':'marquise','heart':'heart','radiant':'radiant','asscher':'asscher'};
      var availableShapes = {};
      var variantShapes = findAvailableShapesFromDOM();
      if (variantShapes && variantShapes.length > 0) {
        variantShapes.forEach(function(s) {
          var lower = (s || '').toLowerCase();
          for (var word in SW) if (lower.indexOf(word) !== -1) availableShapes[SW[word]] = true;
        });
        console.log('[Luma] filterAvailableShapes: via variants ->', Object.keys(availableShapes).join(', ') || '(none recognised)');
      }
      if (Object.keys(availableShapes).length === 0) {
        var sources = [];
        document.querySelectorAll('[id^="Slider-Gallery"] > li img, .product__media-list > li img').forEach(function(img) { sources.push(img.getAttribute('src') || img.getAttribute('data-src') || img.src || ''); });
        if (sources.length === 0) document.querySelectorAll('[id^="GalleryThumbnails"] button img, [id^="Slider-Thumbnails"] button img, .thumbnail-list__item button img').forEach(function(img) { sources.push(img.getAttribute('src') || img.getAttribute('data-src') || img.src || ''); });
        var altSources = [];
        document.querySelectorAll('[id^="Slider-Gallery"] > li img, .product__media-list > li img, [id^="GalleryThumbnails"] button img, [id^="Slider-Thumbnails"] button img, .thumbnail-list__item button img').forEach(function(img) { altSources.push((img.getAttribute('alt') || '').toLowerCase()); });
        sources.forEach(function(src) { var sh = shapeFromSrc(src); if (sh) availableShapes[sh] = true; });
        altSources.forEach(function(alt) { var sh = shapeFromAlt(alt); if (sh) availableShapes[sh] = true; });
        if (Object.keys(availableShapes).length) console.log('[Luma] filterAvailableShapes: via images ->', Object.keys(availableShapes).join(', '));
      }
      if (Object.keys(availableShapes).length === 0) { console.log('[Luma] filterAvailableShapes: no shapes detected; showing all.'); return; }
      qsa('.luma-config__shape-btn').forEach(function(btn) {
        var sh = (btn.getAttribute('data-shape') || '').toLowerCase();
        if (sh && !availableShapes[sh]) btn.style.display = 'none';
        else btn.style.display = '';
      });
    }
    setTimeout(filterAvailableShapes, 350);

    var nativeForm = wrap.closest('.product-form, form[action*="/cart/add"]');
    if (!nativeForm) nativeForm = document.querySelector('.product-form');
    if (nativeForm && nativeForm.id !== 'luma-config-form') nativeForm.classList.add('luma-config-active');
    document.body.classList.add('luma-config-active');
    function setInlineDisplay(a, v) { var e = qs('[' + a + ']'); if (e) e.textContent = v || ''; }

    // ═══ GALLERY IMAGE SWITCHING (preserves metal selection) ═══
    var SHAPE_CODES = { 'RD':'round','RN':'round','RO':'round','OV':'oval','ON':'oval','OL':'oval','CU':'cushion','PR':'princess','PN':'princess','EM':'emerald','PE':'pear','MQ':'marquise','HRT':'heart','RAD':'radiant','AS':'asscher' };
    var SHAPE_WORDS = {'round':'round','oval':'oval','cushion':'cushion','princess':'princess','emerald':'emerald','pear':'pear','marquise':'marquise','heart':'heart','radiant':'radiant','asscher':'asscher'};
    function shapeFromSrc(src) {
      if (!src) return null;
      var f = src.split('/').pop().split('?')[0].toUpperCase();
      var m = f.match(/^[A-Z]\d{3,4}([A-Z]{2,3})\d{2,3}[_\-.]/);
      if (m && SHAPE_CODES[m[1]]) return SHAPE_CODES[m[1]];
      var parts = f.split(/[_\-.]/);
      for (var i = 0; i < parts.length; i++) if (SHAPE_CODES[parts[i]]) return SHAPE_CODES[parts[i]];
      var l = f.toLowerCase();
      for (var w in SHAPE_WORDS) if (l.indexOf(w) !== -1) return SHAPE_WORDS[w];
      return null;
    }
    function shapeFromAlt(a) { if (!a) return null; var l = a.toLowerCase(); for (var w in SHAPE_WORDS) if (l.indexOf(w) !== -1) return SHAPE_WORDS[w]; return null; }
    function metalFromSrc(src) {
      if (!src) return null;
      var f = src.split('/').pop().split('?')[0].toUpperCase();
      var t = f.split(/[_\-.]/);
      for (var i = 0; i < t.length; i++) {
        if (t[i] === 'YELLOW') return 'YELLOW';
        if (t[i] === 'ROSE') return 'ROSE';
        if (t[i] === 'WHITE') return 'WHITE';
        if (t[i] === 'PLATINUM') return 'WHITE';
      }
      return null;
    }
    function metalFromAlt(a) {
      if (!a) return null;
      var l = a.toLowerCase();
      if (l.indexOf('yellow') !== -1) return 'YELLOW';
      if (l.indexOf('rose') !== -1) return 'ROSE';
      if (l.indexOf('white') !== -1) return 'WHITE';
      if (l.indexOf('platinum') !== -1) return 'WHITE';
      return null;
    }
    function metalColourFromState(ms) {
      if (!ms) return null;
      var m = ms.toLowerCase();
      if (m.indexOf('yellow') !== -1) return 'YELLOW';
      if (m.indexOf('rose') !== -1) return 'ROSE';
      if (m.indexOf('white') !== -1) return 'WHITE';
      if (m.indexOf('platinum') !== -1) return 'WHITE';
      return null;
    }
    function detectShape(el) {
      if (!el) return null;
      var img = el.querySelector('img');
      if (!img) return null;
      var ba = shapeFromAlt(img.getAttribute('alt') || '');
      if (ba) return ba;
      var src = img.getAttribute('src') || img.getAttribute('data-src') || img.src || '';
      return shapeFromSrc(src);
    }
    function detectMetal(el) {
      if (!el) return null;
      var img = el.querySelector('img');
      if (!img) return null;
      var src = img.getAttribute('src') || img.getAttribute('data-src') || img.src || '';
      var bs = metalFromSrc(src);
      if (bs) return bs;
      return metalFromAlt(img.getAttribute('alt') || '');
    }
    function activateSlide(slide, mg) {
      var mid = slide.getAttribute('data-media-id');
      if (mid && mg && typeof mg.setActiveMedia === 'function') { mg.setActiveMedia(mid, false); return true; }
      return false;
    }
    function switchToShapeImage(shape) {
      if (!shape) return;
      var ts = shape.toLowerCase();
      var tm = metalColourFromState(state.metal);
      var mg = document.querySelector('media-gallery');
      var slides = Array.prototype.slice.call(document.querySelectorAll('[id^="Slider-Gallery"] > li, .product__media-list > li'));
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('[id^="GalleryThumbnails"] button, [id^="Slider-Thumbnails"] button, .thumbnail-list__item button'));
      function pb(cs) {
        var sm = null, so = null;
        for (var i = 0; i < cs.length; i++) {
          var c = cs[i];
          if (detectShape(c) !== ts) continue;
          if (!so) so = c;
          if (tm && detectMetal(c) === tm) { sm = c; break; }
        }
        if (sm) return sm;
        if (!tm && so) return so;
        return null;
      }
      var bs = pb(slides);
      if (bs && activateSlide(bs, mg)) { console.log('[Luma] switchToShapeImage: matched "' + ts + (tm ? ' + ' + tm : '') + '" via slide.'); return; }
      var bt = pb(thumbs);
      if (bt) { bt.click(); console.log('[Luma] switchToShapeImage: matched "' + ts + (tm ? ' + ' + tm : '') + '" via thumbnail.'); return; }
      if (tm) console.log('[Luma] switchToShapeImage: no "' + ts + ' + ' + tm + '" image; keeping current gallery.');
      else console.warn('[Luma] switchToShapeImage: no match for "' + ts + '".');
    }
    function switchToMetalImage(metal) {
      if (!metal) return;
      var tm = metalColourFromState(metal);
      if (!tm) return;
      var ts = state.shape ? state.shape.toLowerCase() : null;
      var mg = document.querySelector('media-gallery');
      var slides = Array.prototype.slice.call(document.querySelectorAll('[id^="Slider-Gallery"] > li, .product__media-list > li'));
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('[id^="GalleryThumbnails"] button, [id^="Slider-Thumbnails"] button, .thumbnail-list__item button'));
      function pb(cs) {
        var sm = null, mo = null;
        for (var i = 0; i < cs.length; i++) {
          var c = cs[i];
          if (detectMetal(c) !== tm) continue;
          if (!mo) mo = c;
          if (ts && detectShape(c) === ts) { sm = c; break; }
        }
        if (sm) return sm;
        if (mo) return mo;
        return null;
      }
      var bs = pb(slides);
      if (bs && activateSlide(bs, mg)) { console.log('[Luma] switchToMetalImage: matched "' + tm + (ts ? ' + ' + ts : '') + '" via slide.'); return; }
      var bt = pb(thumbs);
      if (bt) { bt.click(); return; }
      console.warn('[Luma] switchToMetalImage: no match for "' + metal + '".');
    }
  });
})();
/* ================================================================
   LUMA RECOMMENDS BADGE - STYLES
   Added 27 August 2026.

   Draws the badge from the data-luma-recommended attribute that
   renderDiamonds() puts on each card, which comes from the API's
   luma_recommended flag. The decision lives server side in
   api/_lib/diamond-quality.js; this only draws it.

   WHY THE CSS IS INJECTED FROM JS RATHER THAN LIVING IN A
   STYLESHEET, WHICH IS WHERE IT BELONGS:
   assets/luma-product-configurator.css and
   snippets/luma-product-configurator.liquid both contain many
   hand-typed box-drawing rule runs of differing lengths in their
   comment banners. Those cannot be reproduced byte-exactly through
   the Shopify theme text API, and two attempts to write that CSS
   file this month silently mangled the runs while keeping a
   plausible file size.
   This file carries only short, uniform 3-character banner runs, so
   it has round-tripped through the API cleanly and verifiably. That
   is an observed result for THIS file, not a general rule: check any
   file for long variable-length rule runs before editing it via the
   API, and prefer the Shopify CLI, which preserves bytes.

   MOVE THEM to luma-product-configurator.css the next time anyone
   runs the Shopify CLI, which preserves bytes. Delete this block
   when you do.
   ================================================================ */
(function () {
  var STYLE_ID = 'luma-rec-badge-styles';
  function inject() {
    if (document.getElementById(STYLE_ID)) return;
    if (!document.getElementById('luma-config')) return;
    var css = [
      '.luma-config__diamond-card[data-luma-recommended="true"] .luma-config__diamond-specs::after {',
      '  content: "Luma Recommends";',
      '  display: block;',
      '  width: fit-content;',
      '  margin-top: 5px;',
      '  padding: 2px 7px;',
      '  background: #1C3320;',
      '  color: #ffffff;',
      '  font-size: 9px;',
      '  font-weight: 600;',
      '  line-height: 1.6;',
      '  letter-spacing: 0.05em;',
      '  text-transform: uppercase;',
      '  white-space: nowrap;',
      '  border-radius: 2px;',
      '}',
      '#luma-config[data-luma-only-rec="true"] .luma-config__diamond-card:not([data-luma-shortlist="true"]) {',
      '  display: none;',
      '}',
      '.luma-rec-note__more { display: none; }',
      '#luma-config[data-luma-only-rec="true"] .luma-rec-note__more { display: inline; }',
      '.luma-rec-note {',
      '  display: block;',
      '  margin-top: 10px;',
      '  padding: 9px 11px;',
      '  background: #F8F6F1;',
      '  border: 1px solid #E8D5A3;',
      '  border-radius: 0;',
      '  color: #5a5248;',
      '  font-size: 11px;',
      '  line-height: 1.5;',
      '  text-transform: none;',
      '  letter-spacing: 0;',
      '  font-weight: 400;',
      '}',
      '.luma-rec-note__label {',
      '  color: #C9A456;',
      '  font-weight: 600;',
      '  letter-spacing: 0.5px;',
      '  text-transform: uppercase;',
      '  font-size: 10px;',
      '}',
      '.luma-rec-note a {',
      '  color: #1C3320;',
      '  font-weight: 600;',
      '  text-decoration: underline;',
      '  white-space: nowrap;',
      '}',
      '.luma-rec-toggle {',
      '  display: inline-flex;',
      '  align-items: center;',
      '  margin-top: 9px;',
      '  padding: 6px 14px;',
      '  border: 1px solid #1C3320;',
      '  border-radius: 20px;',
      '  background: #ffffff;',
      '  color: #1C3320;',
      '  font-size: 10px;',
      '  font-weight: 600;',
      '  letter-spacing: 1px;',
      '  text-transform: uppercase;',
      '  line-height: 1.4;',
      '  cursor: pointer;',
      '  transition: background 0.15s ease, color 0.15s ease;',
      '}',
      '.luma-rec-toggle::before {',
      '  content: "";',
      '  display: inline-block;',
      '  width: 8px;',
      '  height: 8px;',
      '  margin-right: 7px;',
      '  border: 1px solid currentColor;',
      '  border-radius: 50%;',
      '  background: transparent;',
      '}',
      '.luma-rec-toggle:hover {',
      '  background: #1C3320;',
      '  color: #ffffff;',
      '}',
      '.luma-rec-toggle[aria-pressed="true"] {',
      '  background: #1C3320;',
      '  color: #ffffff;',
      '}',
      '.luma-rec-toggle[aria-pressed="true"]::before {',
      '  background: currentColor;',
      '}',
      '.luma-rec-toggle:focus-visible {',
      '  outline: 2px solid #C9A456;',
      '  outline-offset: 2px;',
      '}'
    ].join('\n');
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.appendChild(document.createTextNode(css));
    document.head.appendChild(el);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
/* ================================================================
   LUMA RECOMMENDS - "RECOMMENDED ONLY" TOGGLE
   Added 28 August 2026.

   Adds a toggle beside the results count that hides every stone
   without the badge. Filtering is done entirely by CSS from the
   data-luma-only-rec attribute, so this script only flips an
   attribute and never touches the diamond list itself.

   The toggle is REMOVED, not disabled, when no stone in the current
   results qualifies. Offering a filter that empties the grid is
   worse than not offering it.
   ================================================================ */
(function () {
  var root = document.getElementById('luma-config');
  if (!root) return;

  function sync() {
    var countEl = root.querySelector('.luma-config__diamonds-count');
    if (!countEl) return;

    var anyRec = root.querySelector('.luma-config__diamond-card[data-luma-shortlist="true"]');
    var toggle = countEl.querySelector('.luma-rec-toggle');

    if (!anyRec) {
      if (toggle) toggle.parentNode.removeChild(toggle);
      var staleNote = countEl.querySelector('.luma-rec-note');
      if (staleNote) staleNote.parentNode.removeChild(staleNote);
      root.removeAttribute('data-luma-only-rec');
      return;
    }

    var note = countEl.querySelector('.luma-rec-note');
    if (!note) {
      note = document.createElement('span');
      note.className = 'luma-rec-note';
      var lbl = document.createElement('strong');
      lbl.className = 'luma-rec-note__label';
      lbl.textContent = 'Luma Recommends';
      note.appendChild(lbl);
      note.appendChild(document.createTextNode(
        ' marks the best proportioned stones for this shape. We may still suggest an alternative if we find one that suits your ring better. '
      ));
      var link = document.createElement('a');
      link.href = '/pages/how-we-choose-your-diamond';
      link.textContent = 'Learn more';
      note.appendChild(link);
      countEl.appendChild(note);
    }

    if (toggle) return;

    toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'luma-rec-toggle';
    toggle.setAttribute('aria-pressed', 'false');
    toggle.textContent = 'Luma Recommends';
    toggle.addEventListener('click', function () {
      var on = root.getAttribute('data-luma-only-rec') === 'true';
      if (on) {
        root.removeAttribute('data-luma-only-rec');
        toggle.setAttribute('aria-pressed', 'false');
        toggle.textContent = 'Luma Recommends';
      } else {
        root.setAttribute('data-luma-only-rec', 'true');
        toggle.setAttribute('aria-pressed', 'true');
        toggle.textContent = 'Showing Luma Recommends';
      }
    });
    countEl.appendChild(toggle);
  }

  function tick() { try { sync(); } catch (e) { /* never break the configurator */ } }

  var obs = new MutationObserver(tick);
  obs.observe(root, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();

/* ================================================================
   LUMA - REQUIRED CONTACT DETAILS ON THE CONFIGURATOR
   Added 31 August 2026.

   WHY THIS EXISTS
   The configurator used to create a draft order with no customer, no
   email and no phone. The customer typed nothing until Shopify's
   invoice page, at the moment of paying. So every ring that was
   configured but not paid for left a draft order holding a diamond,
   a metal and a size, and no way to tell whose it was. There are
   nineteen of those sitting open, back to 20 May 2026.

   Asher, 31 Aug: "we'd like to make phone number a needed entry when
   you make an engagement ring purchase as well as email so we don't
   have to go through this again."

   WHY IT IS APPENDED HERE RATHER THAN ADDED TO THE LIQUID
   The markup for this belongs in snippets/luma-product-configurator
   .liquid. That file carries 929 box-drawing characters in runs up to
   77 long, and CANNOT be written through the Shopify theme text API
   without silent corruption. This file's banners use short uniform
   runs and round-trip cleanly, so the fields are built in JS instead.
   Move them into the Liquid the next time anyone runs the Shopify
   CLI, which preserves bytes, and delete this note.

   HOW IT HOOKS IN WITHOUT TOUCHING THE EXISTING CODE
   1. Fields are injected into step 4 above the deposit notice.
   2. Validation runs on a CAPTURE phase listener on `document`. That
      matters: a listener added to the form itself would run AFTER the
      configurator's own submit handler, because same-element
      listeners fire in registration order regardless of the capture
      flag. Capturing at document level stops the event before it ever
      reaches the form.
   3. The values are added to the request body by wrapping fetch,
      the same pattern the badge script uses, so the existing submit
      handler needs no changes at all.

   If anything in here throws, the configurator carries on exactly as
   it does today. Nothing below is allowed to block an order.
   ================================================================ */
(function () {
  var root = document.getElementById('luma-config');
  if (!root) return;

  var STYLE_ID = 'luma-contact-styles';
  var FIELDS = [
    { key: 'name',  label: 'Full name',    type: 'text',  autocomplete: 'name' },
    { key: 'email', label: 'Email address', type: 'email', autocomplete: 'email' },
    { key: 'phone', label: 'Phone number',  type: 'tel',   autocomplete: 'tel' }
  ];

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      '.luma-contact {',
      '  margin: 18px 0 4px;',
      '  padding: 16px 16px 14px;',
      '  background: #F8F6F1;',
      '  border: 1px solid #E8D5A3;',
      '}',
      '.luma-contact__title {',
      '  margin: 0 0 4px;',
      '  font-size: 11px;',
      '  font-weight: 600;',
      '  letter-spacing: 0.08em;',
      '  text-transform: uppercase;',
      '  color: #1C3320;',
      '}',
      '.luma-contact__intro {',
      '  margin: 0 0 12px;',
      '  font-size: 12px;',
      '  line-height: 1.5;',
      '  color: #5a5248;',
      '}',
      '.luma-contact__row { margin-bottom: 10px; }',
      '.luma-contact__row:last-of-type { margin-bottom: 0; }',
      '.luma-contact__label {',
      '  display: block;',
      '  margin-bottom: 4px;',
      '  font-size: 11px;',
      '  letter-spacing: 0.04em;',
      '  color: #1C3320;',
      '}',
      '.luma-contact__input {',
      '  display: block;',
      '  width: 100%;',
      '  box-sizing: border-box;',
      '  padding: 9px 10px;',
      '  border: 1px solid #d8d2c6;',
      '  border-radius: 0;',
      '  background: #ffffff;',
      '  font-size: 14px;',
      '  line-height: 1.4;',
      '  color: #111111;',
      '}',
      '.luma-contact__input:focus {',
      '  outline: none;',
      '  border-color: #1C3320;',
      '}',
      '.luma-contact__row.is-bad .luma-contact__input { border-color: #A6342B; }',
      '.luma-contact__err {',
      '  display: none;',
      '  margin-top: 4px;',
      '  font-size: 11px;',
      '  color: #A6342B;',
      '}',
      '.luma-contact__row.is-bad .luma-contact__err { display: block; }'
    ].join('\n');
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.appendChild(document.createTextNode(css));
    document.head.appendChild(el);
  }

  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'luma-contact';
    wrap.id = 'luma-contact';

    var h = document.createElement('div');
    h.className = 'luma-contact__title';
    h.textContent = 'Your details';
    wrap.appendChild(h);

    var p = document.createElement('p');
    p.className = 'luma-contact__intro';
    p.textContent = 'We look at every stone again before it reaches the bench. ' +
      'If we find one that suits your ring better, we will call you before we make anything.';
    wrap.appendChild(p);

    FIELDS.forEach(function (f) {
      var row = document.createElement('div');
      row.className = 'luma-contact__row';
      row.setAttribute('data-field', f.key);

      var lab = document.createElement('label');
      lab.className = 'luma-contact__label';
      lab.setAttribute('for', 'luma-contact-' + f.key);
      lab.textContent = f.label;

      var input = document.createElement('input');
      input.className = 'luma-contact__input';
      input.id = 'luma-contact-' + f.key;
      input.type = f.type;
      input.required = true;
      input.setAttribute('autocomplete', f.autocomplete);
      // The field lives outside #luma-config-form in some layouts, so it is
      // deliberately NOT given a name. Values are read by id and put on the
      // request body by the fetch wrapper below.
      input.addEventListener('input', function () { row.classList.remove('is-bad'); });

      var err = document.createElement('div');
      err.className = 'luma-contact__err';

      row.appendChild(lab);
      row.appendChild(input);
      row.appendChild(err);
      wrap.appendChild(row);
    });

    return wrap;
  }

  function mount() {
    var panel = root.querySelector('.luma-config__panel[data-panel="4"]');
    if (!panel || document.getElementById('luma-contact')) return;
    var atc = document.getElementById('luma-config-atc');
    if (!atc) return;
    var nav = atc.closest('.luma-config__nav') || atc;
    // The deposit notice is inserted by updateSummary() just above the nav
    // row. Sit above whichever of the two is present so the customer reads
    // the fields before the terms and the button.
    var notice = panel.querySelector('.luma-config__deposit-notice');
    var before = notice || nav;
    if (!before || !before.parentNode) return;
    injectStyles();
    before.parentNode.insertBefore(build(), before);
  }

  function val(key) {
    var el = document.getElementById('luma-contact-' + key);
    return el ? String(el.value || '').trim() : '';
  }

  function setBad(key, message) {
    var row = document.querySelector('.luma-contact__row[data-field="' + key + '"]');
    if (!row) return;
    row.classList.add('is-bad');
    var err = row.querySelector('.luma-contact__err');
    if (err) err.textContent = message;
  }

  /* Deliberately permissive. The job is to catch an empty box or an obvious
     typo, not to adjudicate what a valid address or number looks like.
     Over-strict validation turns away real customers, and a wrong address
     that parses is caught by the bounce, never by a regex. Nine digits is
     the shortest genuinely reachable number once a country code is stripped;
     a UK mobile is eleven. Spaces, brackets and a leading plus are all fine
     and the value is stored exactly as typed. */
  function validate() {
    if (!document.getElementById('luma-contact')) return { ok: true, skipped: true };
    var bad = [];
    if (val('name').length < 2) {
      setBad('name', 'Please enter your name.');
      bad.push('name');
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val('email'))) {
      setBad('email', 'Please enter an email address we can reach you on.');
      bad.push('email');
    }
    if ((val('phone').match(/\d/g) || []).length < 9) {
      setBad('phone', 'Please enter a phone number, including the area code.');
      bad.push('phone');
    }
    return { ok: bad.length === 0, bad: bad };
  }

  /* CAPTURE PHASE, ON DOCUMENT, ON PURPOSE.
     A submit listener added to the form would fire AFTER the configurator's
     own handler, because listeners on the element a submit event targets run
     in registration order whether or not they are capturing. Capturing at
     document level stops the event before it reaches the form at all. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'luma-config-form') return;
    var v;
    try { v = validate(); } catch (err) { return; }   // never block on our bug
    if (v.ok) return;
    e.preventDefault();
    e.stopPropagation();
    var first = document.querySelector('.luma-contact__row.is-bad .luma-contact__input');
    if (first) {
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      first.focus({ preventScroll: true });
    }
  }, true);

  /* The existing submit handler builds its own payload object and posts it.
     Rather than edit that handler, wrap fetch and add the three fields on the
     way past. Same pattern as the badge script. If this throws, the order
     still goes through, and the server tags it missing-contact rather than
     failing. */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      if (init && String(init.method || '').toUpperCase() === 'POST' &&
          url.indexOf('/api/create-draft-order') !== -1 &&
          typeof init.body === 'string') {
        var b = JSON.parse(init.body);
        b.customer_name  = val('name');
        b.customer_email = val('email');
        b.customer_phone = val('phone');
        init = Object.assign({}, init, { body: JSON.stringify(b) });
      }
    } catch (err) { /* never block an order over this */ }
    return nativeFetch.call(this, input, init);
  };

  function tick() { try { mount(); } catch (e) { /* never break the configurator */ } }

  var obs = new MutationObserver(tick);
  obs.observe(root, { childList: true, subtree: true });
  root.addEventListener('click', function () { setTimeout(tick, 60); }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();

/* ================================================================
   LUMA - EXPANDABLE DIAMOND DETAIL  (v2)
   Added 31 August 2026. v1 same day, replaced within the hour.

   WHY
   The card showed carat, shape, clarity, colour, cut and the report
   number. Asher: "the customer doesn't get to see many specs other
   than the carat, however I'd like to make it quite sleak so it
   doesn't muddy up the design."

   NO OUTBOUND LINK TO IGI, DELIBERATELY. An earlier draft made the
   report number a link to IGI's verification page. Asher, correctly:
   "I don't want them leaving our site and seeing the stone on IGI I
   also think that has more potential to slow the process." The number
   is shown so anyone who wants to check can, in their own time. It is
   not an exit placed in the middle of a purchase. Do not make it a
   link again.

   -- WHAT WAS WRONG WITH v1, both worth remembering ------

   1. EVERY PANEL WAS ALWAYS OPEN. v1 hid panels with the `hidden`
      attribute, while its own CSS said `.luma-detail__panel {
      display: grid }`. A class selector beats the user-agent's
      `[hidden] { display: none }`, so `panel.hidden = true` did
      nothing at all and the Details button toggled an attribute with
      no effect. Hence the "muddy" list.
      THE RULE: any element you intend to hide with `hidden` needs an
      explicit `[hidden] { display: none }` of at least equal
      specificity whenever you also give it a display value.

   2. THE PRICE FLOATED INTO THE MIDDLE OF THE PANEL. Nothing was
      overlapping by accident. `.luma-config__diamond-card` is
      `display: flex` with `align-items: center`, and v1 put the panel
      INSIDE `.luma-config__diamond-info`. That made the info column
      tall, so the price, a normal flex item, centred itself
      vertically against it and landed halfway down the specs.
      THE FIX: the panel is now a child of the CARD, taking a full
      flex line of its own below the existing row. That is the same
      idiom `.luma-config__deposit-notice` already uses in this
      theme's CSS: width 100%, flex-basis 100%, border-box.

   -- THE INTERACTION ------
   Asher: "only increase the size of the diamond selected, then maybe
   it goes back to the small size once the customer starts scrolling
   again? so it only shows when they're looking at that particular
   stone?"

   So: one open at a time, and an open panel closes itself when its
   card scrolls out of the diamond list's viewport. That is done with
   an IntersectionObserver rooted on the scrolling list, not a scroll
   handler, so it costs nothing while idle and never fires mid-scroll
   on a card the customer is still reading.

   -- THE ONE NON-OBVIOUS BIT ------
   Every card has a click handler that SELECTS that diamond. The
   Details button and the panel both sit inside the card, so without
   stopPropagation a click to read or to select the certificate number
   would silently change the customer's chosen stone and the price on
   the page. The card also inherits `cursor: pointer` and
   `user-select: none`, so the panel resets both, otherwise the report
   number cannot be selected or copied.

   If anything here throws, the configurator carries on exactly as it
   does today. Nothing below may block a search or an order.
   ================================================================ */
(function () {
  var root = document.getElementById('luma-config');
  if (!root) return;

  var API = root.getAttribute('data-diamond-api') || '';
  var STYLE_ID = 'luma-detail-styles';
  var OPEN_CLASS = 'luma-detail-open';
  var certs = {};        // diamond id -> certificate
  var entries = [];      // { card, btn, panel } for every decorated card

  /* ---- 1. capture certificates from the search response ---- */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = nativeFetch.call(this, input, init);
    if (API && url.indexOf(API) === 0) {
      try {
        p.then(function (res) {
          res.clone().json().then(function (j) {
            var items = (j && j.data && j.data.as && j.data.as.diamonds_by_query &&
                         j.data.as.diamonds_by_query.items) || [];
            certs = {};
            items.forEach(function (d) {
              if (d && d.id && d.diamond && d.diamond.certificate) {
                certs[String(d.id)] = d.diamond.certificate;
              }
            });
            entries = [];          // list re-rendered, old cards are gone
          }).catch(function () {});
        }).catch(function () {});
      } catch (e) { /* never interfere with the search */ }
    }
    return p;
  };

  /* ---- 2. formatting ---- */
  function num(v) {
    if (v === null || v === undefined || v === '') return null;
    var n = Number(v);
    return isFinite(n) ? n : null;
  }

  function pct(v) {
    var n = num(v);
    return n === null ? null : n.toFixed(1) + '%';
  }

  function measurements(c) {
    var l = num(c.length), w = num(c.width);
    if (l === null || w === null) return null;
    return l.toFixed(2) + ' × ' + w.toFixed(2) + ' mm';
  }

  function ratio(c) {
    var r = num(c.ratio);
    if (r === null) {
      var l = num(c.length), w = num(c.width);
      if (l !== null && w !== null && w > 0) r = l / w;
    }
    return r === null ? null : r.toFixed(2);
  }

  var FLUOR_LABEL = {
    NON: 'None', NONE: 'None', N: 'None', NIL: 'None', '0': 'None',
    FNT: 'Faint', FAINT: 'Faint', MED: 'Medium', MEDIUM: 'Medium',
    STG: 'Strong', STRONG: 'Strong', VST: 'Very strong'
  };
  function fluor(c) {
    var raw = c.floInt;
    if (raw === null || raw === undefined || raw === '') raw = c.fluorescence;
    if (raw === null || raw === undefined || raw === '') return null;
    var k = String(raw).trim().toUpperCase();
    return FLUOR_LABEL[k] || String(raw).trim();
  }

  var GIRDLE_LABEL = {
    ETN: 'Extremely thin', VTN: 'Very thin', THN: 'Thin', STN: 'Slightly thin',
    MED: 'Medium', STK: 'Slightly thick', THK: 'Thick', VTK: 'Very thick',
    ETK: 'Extremely thick'
  };
  function girdle(c) {
    if (!c.girdle) return null;
    var parts = String(c.girdle).toUpperCase().split(/\s+TO\s+|\s*-\s*|\s*\/\s*/)
      .map(function (s) { return s.replace(/[^A-Z]/g, ''); }).filter(Boolean);
    if (!parts.length) return String(c.girdle);
    var out = parts.map(function (p) { return GIRDLE_LABEL[p] || p; });
    return out.length > 1 ? out[0] + ' to ' + out[out.length - 1].toLowerCase() : out[0];
  }

  function grown(c) {
    var g = c.labgrown_type || c.growthType || c.growth_type || c.labgrownType;
    if (!g) return null;
    var s = String(g).trim().toUpperCase();
    if (s.indexOf('CVD') !== -1) return 'CVD';
    if (s.indexOf('HPHT') !== -1) return 'HPHT';
    return String(g).trim();
  }

  function certificate(c) {
    var lab = c.lab && String(c.lab).toUpperCase() !== 'NONE' ? String(c.lab) : null;
    var n = c.certNumber ? String(c.certNumber) : null;
    if (!lab && !n) return null;
    return [lab, n].filter(Boolean).join(' ');
  }

  /* ---- 3. build the panel ---- */
  function rows(c) {
    return [
      ['Measurements', measurements(c)],
      ['Ratio',        ratio(c)],
      ['Table',        pct(c.table)],
      ['Depth',        pct(c.depthPercentage || c.depth_percentage)],
      ['Polish',       c.polish   || null],
      ['Symmetry',     c.symmetry || null],
      ['Girdle',       girdle(c)],
      ['Fluorescence', fluor(c)],
      ['Grown',        grown(c)],
      ['Certificate',  certificate(c)]
    ].filter(function (r) { return r[1] !== null && r[1] !== ''; });
  }

  function buildPanel(c) {
    var panel = document.createElement('div');
    panel.className = 'luma-detail__panel';
    panel.hidden = true;
    var list = rows(c);
    if (!list.length) {
      var none = document.createElement('div');
      none.className = 'luma-detail__empty';
      none.textContent = 'Full measurements for this stone are not available.';
      panel.appendChild(none);
      return panel;
    }
    list.forEach(function (r) {
      var k = document.createElement('span');
      k.className = 'luma-detail__k';
      k.textContent = r[0];
      var v = document.createElement('span');
      v.className = 'luma-detail__v';
      v.textContent = r[1];
      panel.appendChild(k);
      panel.appendChild(v);
    });
    // The card is click-to-select. Reading or copying the certificate number
    // must not change the customer's chosen stone.
    panel.addEventListener('click', function (e) { e.stopPropagation(); });
    return panel;
  }

  function close(entry) {
    if (!entry) return;
    entry.btn.setAttribute('aria-expanded', 'false');
    entry.btn.textContent = 'Details';
    entry.panel.hidden = true;
    entry.card.classList.remove(OPEN_CLASS);
  }

  function closeAll(except) {
    entries.forEach(function (e) { if (e !== except) close(e); });
  }

  function open(entry) {
    closeAll(entry);
    entry.btn.setAttribute('aria-expanded', 'true');
    entry.btn.textContent = 'Hide details';
    entry.panel.hidden = false;
    entry.card.classList.add(OPEN_CLASS);
    watch(entry.card);
  }

  /* ---- 4. close on scroll away ------
     IntersectionObserver rather than a scroll handler: it fires only when a
     card actually leaves the list's viewport, costs nothing while idle, and
     will not collapse a panel the customer is still scrolling through. */
  var io = null;
  function watch(card) {
    try {
      var grid = root.querySelector('.luma-config__diamonds-grid');
      if (!grid) return;
      if (!io) {
        io = new IntersectionObserver(function (recs) {
          recs.forEach(function (r) {
            if (r.isIntersecting) return;
            var entry = entries.filter(function (e) { return e.card === r.target; })[0];
            if (entry && entry.btn.getAttribute('aria-expanded') === 'true') close(entry);
            io.unobserve(r.target);
          });
        }, { root: grid, threshold: 0.15 });
      }
      io.observe(card);
    } catch (e) { /* auto-close is a nicety, not a requirement */ }
  }

  function decorate(card) {
    if (card.querySelector('.luma-detail__btn')) return;
    var id = card.getAttribute('data-diamond-id');
    var c = certs[String(id)];
    if (!c) return;                       // no data yet, try again next tick

    var info = card.querySelector('.luma-config__diamond-info');
    if (!info) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'luma-detail__btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Details';

    var panel = buildPanel(c);
    var entry = { card: card, btn: btn, panel: panel };
    entries.push(entry);

    function toggle(e) {
      e.preventDefault();
      e.stopPropagation();               // the card selects the diamond
      if (btn.getAttribute('aria-expanded') === 'true') close(entry);
      else open(entry);
    }

    btn.addEventListener('click', toggle);
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { toggle(e); }
      else { e.stopPropagation(); }       // card also listens for Enter and Space
    });

    // Button beside the specs. Panel on its OWN full-width flex line at the
    // bottom of the card, so the price stays where it belongs. See the note
    // at the top about why v1 put it in the wrong place.
    info.appendChild(btn);
    card.appendChild(panel);
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      '.luma-detail__btn {',
      '  display: inline-block;',
      '  margin-top: 5px;',
      '  padding: 0;',
      '  border: 0;',
      '  background: none;',
      '  color: #1C3320;',
      '  font-size: 10px;',
      '  font-weight: 600;',
      '  letter-spacing: 0.06em;',
      '  text-transform: uppercase;',
      '  text-decoration: underline;',
      '  text-underline-offset: 2px;',
      '  cursor: pointer;',
      '}',
      '.luma-detail__btn:hover { color: #C9A456; }',
      '.luma-detail__btn:focus-visible {',
      '  outline: 2px solid #C9A456;',
      '  outline-offset: 2px;',
      '}',
      // A full flex line of its own. The card is display:flex with no wrap by
      // default, so the card gets flex-wrap only while a panel is open.
      '.luma-config__diamond-card.luma-detail-open { flex-wrap: wrap; }',
      '.luma-detail__panel {',
      '  flex: 0 0 100%;',
      '  width: 100%;',
      '  box-sizing: border-box;',
      '  display: grid;',
      '  grid-template-columns: auto 1fr;',
      '  gap: 3px 12px;',
      '  margin-top: 12px;',
      '  padding: 10px 12px;',
      '  background: #F8F6F1;',
      '  border: 1px solid #ece7dc;',
      '  border-radius: 4px;',
      '  font-size: 11px;',
      '  line-height: 1.5;',
      // The card sets both of these; the panel must undo them so the report
      // number can actually be selected and copied.
      '  cursor: auto;',
      '  user-select: text;',
      '  -webkit-user-select: text;',
      '}',
      // !! DO NOT REMOVE. Without this, the `display: grid` above beats the
      // user agent's [hidden] rule and every panel is permanently open, which
      // is exactly what shipped in v1.
      '.luma-detail__panel[hidden] { display: none !important; }',
      '.luma-detail__k { color: #8a8175; white-space: nowrap; }',
      '.luma-detail__v { color: #1C3320; text-align: right; }',
      '.luma-detail__empty {',
      '  grid-column: 1 / -1;',
      '  color: #8a8175;',
      '  font-size: 11px;',
      '}'
    ].join('\n');
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.appendChild(document.createTextNode(css));
    document.head.appendChild(el);
  }

  function tick() {
    try {
      var cards = root.querySelectorAll('.luma-config__diamond-card');
      if (!cards.length) return;
      injectStyles();
      for (var i = 0; i < cards.length; i++) decorate(cards[i]);
    } catch (e) { /* never break the configurator */ }
  }

  var obs = new MutationObserver(tick);
  obs.observe(root, { childList: true, subtree: true });
  root.addEventListener('click', function () { setTimeout(tick, 60); }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();

/* ================================================================
   LUMA - AUTO SELECT THE ONLY AVAILABLE SHAPE  (v2)
   Added 31 August 2026. v1 same day, replaced within the hour.

   Asher: "if there is only one option diamond shape available, it's
   automatically clicked? so with the Zella, there's only round, I
   have to make sure it's selected to browse diamonds."

   filterAvailableShapes() already hides the shapes a setting cannot
   be made in, by setting an inline style.display of 'none'. On a
   product like Zella that leaves exactly one button visible, and the
   customer still had to click it before Browse would do anything.
   A click with no choice in it is not a decision, it is a dead step.

   WHY v1 FAILED, AND WHAT CHANGED
   v1 fired on a handful of timers plus a MutationObserver, and on
   Zella it never fired at all: the diagnostic showed exactly one
   visible button and the "done" flag still unset. The observer or
   the timers were losing a race I could not reproduce remotely, and
   guessing at it twice would have cost more than making it not
   matter.

   So v2 does not rely on winning a race. It has three independent
   paths, any ONE of which is sufficient:

     1. A poll every 250ms for 20 seconds. Cheap, and immune to
        whatever ordering defeated the observer.
     2. The MutationObserver, kept, because when it does work it is
        instant.
     3. A capture-phase click listener on Browse. If the customer
        reaches Browse with no shape chosen and exactly one is
        available, it is selected right then, synchronously, before
        the Browse handler runs. This is the one that actually
        guarantees the customer never sees "Please select a diamond
        shape" on a single-shape product, whatever the timers did.

   Path 3 works because a capture listener on `document` runs before
   listeners bound to the button itself, and because .click() on the
   shape button runs its handler synchronously, so state.shape is set
   by the time the Browse handler reads it.

   IT SELECTS, IT DOES NOT SEARCH. Firing the diamond search on page
   load would mean a Nivoda round trip for every visitor who never
   reaches step 3, which is most of them.

   VISIBILITY IS READ FROM THE INLINE STYLE, NOT offsetParent. The
   shape buttons live inside step 3, which is display:none while the
   customer is on step 1, so offsetParent is null for every button at
   that point and an offsetParent test would see zero visible shapes
   and never fire. The inline style is what filterAvailableShapes
   actually sets, so it is what we read.
   ================================================================ */
(function () {
  var root = document.getElementById('luma-config');
  if (!root) return;

  var DONE = 'data-luma-autoshape';

  function soleVisibleShape() {
    var btns = root.querySelectorAll('.luma-config__shape-btn');
    if (!btns.length) return null;
    var visible = null, count = 0;
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].style.display === 'none') continue;
      count++;
      if (count > 1) return null;      // a real choice exists, leave it alone
      visible = btns[i];
    }
    return count === 1 ? visible : null;
  }

  function alreadyChosen() {
    return !!root.querySelector('.luma-config__shape-btn.is-selected');
  }

  // Returns true when there is nothing left to do, so the poll can stop.
  function attempt(force) {
    try {
      if (root.getAttribute(DONE) === 'done') return true;
      var only = soleVisibleShape();
      if (!only) return false;
      if (alreadyChosen()) { root.setAttribute(DONE, 'done'); return true; }
      root.setAttribute(DONE, 'done');
      only.click();
      console.log('[Luma] autoshape: selected "' +
        (only.getAttribute('data-shape') || '?') + '" as the only available shape' +
        (force ? ' (on Browse)' : ''));
      return true;
    } catch (e) {
      console.warn('[Luma] autoshape failed: ' + e.message);
      return true;                     // never retry into an error loop
    }
  }

  /* ---- path 1: poll ---- */
  var ticks = 0;
  var poll = setInterval(function () {
    ticks++;
    if (attempt(false) || ticks > 80) clearInterval(poll);   // 80 x 250ms = 20s
  }, 250);

  /* ---- path 2: observe ---- */
  try {
    var obs = new MutationObserver(function () { attempt(false); });
    obs.observe(root, { childList: true, subtree: true, attributes: true,
                        attributeFilter: ['style', 'class'] });
  } catch (e) { /* observer is a nicety, the poll is the guarantee */ }

  /* ---- path 3: the safety net, on the Browse click ----
     Capture phase on document, so this runs BEFORE the Browse button's own
     handler. .click() below is synchronous, so the shape is registered by the
     time Browse reads state.shape. This is what makes the fix reliable rather
     than merely likely. */
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var browse = t.closest('#luma-browse-btn');
      if (!browse) return;
      if (alreadyChosen()) return;
      var only = soleVisibleShape();
      if (!only) return;               // genuinely ambiguous, let the UI ask
      only.click();
      root.setAttribute(DONE, 'done');
      console.log('[Luma] autoshape: selected on Browse, timers had not run');
    } catch (err) { /* never block the Browse click */ }
  }, true);

  console.log('[Luma] autoshape v2 armed');
})();
